export const ConsentType = Object.freeze({
  RUNTIME_PERMISSIONS: "RUNTIME_PERMISSIONS",
  PAN: "PAN",
  BANKING: "BANKING",
  DIGI_KYC: "DIGI_KYC",
  LOGIN_CONSENT: "LOGIN_CONSENT",
  CIBIL_CONSENT: "CIBIL_CONSENT",
  EKYC: "EKYC",
});

const ConsentKeys ={
  [ConsentType.EKYC]: "ekyc_consent",
  [ConsentType.DIGI_KYC]: "digikyc_consent"
}

export const getConsentPayload = (type, productApplication, consent) => {
  const { customerId, appId, product_type } = productApplication;
  const consentKey = ConsentKeys[type];
  const consent_payload = {
      customerId: customerId,
      appId: appId,
      product_type: product_type,
      type,
      value: {
        [consentKey]: consent,
      },
    };
  return consent_payload;
};
